import { useAuth } from "@clerk/clerk-react";
import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Link as RouterLink } from "react-router-dom";
import { AllRoutes } from "../config/routes";
import theme from "../theme/theme";

const clerkEnabled = Boolean(process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);

const SignedInProjectsLink: React.FC = () => {
  const { isSignedIn } = useAuth();
  if (!isSignedIn) {
    return null;
  }

  return (
    <Button
      component={RouterLink}
      to={AllRoutes.Projects}
      color="inherit"
      sx={{ textTransform: "none", fontWeight: 600 }}
    >
      Projects
    </Button>
  );
};

const Header: React.FC = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const navItems = [
    { name: "About", id: "section-overview" },
    { name: "Education", id: "resume-skill" },
    { name: "Experience", id: "resume-skill" }, // Reusing the ID as per original HTML
    { name: "Testimonials", id: "section-testimonial" },
    { name: "Contact", id: "section-footer" },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setDrawerOpen(false); // Close drawer after clicking a link
  };

  const drawer = (
    <Box onClick={toggleDrawer(false)} sx={{ width: 250 }} role="presentation">
      <List>
        {navItems.map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton onClick={() => scrollToSection(item.id)}>
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#333",
        boxShadow: "none",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          minHeight: { xs: "64px", md: "90px" },
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, color: "primary.main" }}
        >
          <img
            src="/images/logo.png"
            alt="Logo"
            style={{ height: "50px", verticalAlign: "middle" }}
          />
        </Typography>
        {clerkEnabled && <SignedInProjectsLink />}
      </Toolbar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default Header;
